import { UseInfiniteQueryResult, UseQueryResult } from 'react-query';

export const DRAWER_ANIMATE_DURATION = 200;

export type DrawerSize = 'small' | 'medium' | 'large' | 'xlarge';

export const DrawerSizeMap: Record<DrawerSize, number> = {
  small: 550,
  medium: 750,
  large: 900,
  xlarge: 1200,
};

export interface DrawerProps {
  open: boolean;
  onClose: (force?: boolean) => void;
  onChange?: () => void;
  className?: string;
  query?: UseQueryResult | UseInfiniteQueryResult;
  loading?: boolean;
  hideUpdateMenu?: boolean;
  isTopDrawer?: boolean;
  size?: DrawerSize;
  tab?: string;
  persistToUrl?: boolean;
}
